// @flow

import { RemoveButton } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { AddonButton } from '@gandi/ui';

import { useFeatureFlags } from 'src/hooks/useFeatureFlag';

type Props = {
  /** action to set / unset confirmation step  */
  fireConfirmationStep: boolean => void,
};

export default function RemoveButtonFF({
  fireConfirmationStep,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const { FF_CART_OVERVIEW_NDS } = useFeatureFlags();

  if (FF_CART_OVERVIEW_NDS) {
    return (
      <RemoveButton handleRemoveAction={() => fireConfirmationStep(true)} />
    );
  }

  return (
    <AddonButton
      intent="remove"
      size="xs"
      hitzone="overlay"
      onClick={() => fireConfirmationStep(true)}
    >
      {__('Remove')}
    </AddonButton>
  );
}
